import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { LanguageProvider } from './contexts/LanguageContext';

import './App.css';

import LoadingHome from './components/loading/LoadingHome';
import Cursor from './components/cursor/Cursor';
import Header from './components/header/Header';
import ScrollToTop from './components/Scroll/ScrollToTop';

import Intro from './pages/homePage/intro/Intro';
import About from './pages/homePage/about/About';
import Portfolio from './pages/homePage/portfolio/Portfolio';
import Services from './pages/homePage/services/Services';
import Contact from './pages/homePage/contact/Contact';
import Footer from './pages/homePage/footer/Footer';
import Price from './pages/pricePage/Price';

const pageVariants = {
  initial: { opacity: 0, y: 16 },
  animate: { opacity: 1, y: 0, transition: { duration: 0.55, ease: [0.22, 1, 0.36, 1] } },
  exit:    { opacity: 0, y: -12, transition: { duration: 0.3 } },
};

function HomePage() {
  return (
    <motion.div
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      className="page-wrapper"
    >
      <Intro />
      <About />
      <Portfolio />
      <Services />
      <Price />
      <Contact />
      <Footer />
    </motion.div>
  );
}

export default function App() {
  const [loaded, setLoaded] = useState(false);

  return (
    <LanguageProvider>
      <BrowserRouter>
        <Cursor />
        <AnimatePresence mode="wait">
          {!loaded && (
            <LoadingHome key="loading" onFinish={() => setLoaded(true)} />
          )}
        </AnimatePresence>
        {loaded && (
          <>
            <Header />
            <ScrollToTop />
            <AnimatePresence mode="wait">
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="*" element={<HomePage />} />
              </Routes>
            </AnimatePresence>
          </>
        )}
      </BrowserRouter>
    </LanguageProvider>
  );
}
